import React, {useState, useEffect} from 'react';
import {Logo} from "../components/Logos/Logo"
import MainImage from "./MainImage"
import NewsText from "./NewsText"
import {BottomAd} from "../components/adfoxBlocks/BottomAd"
import {AdfoxBlock} from "../components/adfoxBlocks/AdfoxBlock"
import Sidebar from "./Sidebar"
import SmiWidget from "../components/smiWidgets/SmiWidget"
import SmiJs from "../components/SmiJs"
import BlurReload from "../utils/blurReload"
import BackClick from "../components/smiWidgets/BackClick";
import Popup from "../components/smiWidgets/Popup";
import {adfoxOptions} from "./adfox/adfoxOptions"
import {widgetIds} from "./smiWidgets/widgetIds"
import {AdfoxInvisible} from "../components/adfoxBlocks/InvisibleAdfox"
import {AdfoxHeaderBidding} from "../components/AdfoxHeaderBidding"
import MoeVideo from "../components/smiWidgets/MoeVideo"
import {hbConfig} from "./HeaderBidding/HBConfig"
import {SourceInfo} from "../components/SourceInfo/SourceInfo"

export default function Template2001Component({
    news,
    context,
    isFull,
    isDesktop,
    showPopUp,
    showBackClick,
    refreshTime,
    popUpType,
    showMainLogo,
    fprVersion,
    currentDomain
}) {

    const showFullscreen = fprVersion === "14556_new" && !isDesktop

    const adBlocks = adfoxOptions[fprVersion] || adfoxOptions['main']
    const widgetBlocks = widgetIds[fprVersion] || widgetIds['main']

    let sid = context.analytics_lable;

    

    return (
        <div id="wrapper">
            <AdfoxHeaderBidding hbConfig={hbConfig} templateVersion={fprVersion}/>
            {showBackClick && <BackClick mode="redirect" isDesktop={isDesktop} adIds={widgetBlocks.backClick} domain={currentDomain} showFullscreen={showFullscreen}/>}
            {showPopUp && <Popup isDesktop={isDesktop} popUpType={popUpType} adIds={widgetBlocks.popup} domain={currentDomain}/>}
            <BlurReload isDesktop={isDesktop} domain={currentDomain} refresh={widgetBlocks.refresh} sid={sid} timeout={refreshTime}/>
            <SmiJs context={context}/>
            <SmiWidget blockIds={widgetBlocks.push} isFull={isFull} isDesktop={isDesktop}/>
            <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.fullscreen}/>
            <img src="https://data.24smi.net/ctp?id=1" width="1" height="1"/>
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo isDark={true} showMainLogo={showMainLogo}/>
                        </a>
                    </strong>
                </header>
                <main id="main">
                    <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.topad}/>
                    <div className="main-holder flex">
                        <section id="content">
                            <div className="post-picture">
                                <div className="news-title-200">{news.title}</div>
                                <MainImage news={news}/>
                                <SourceInfo url={news.source_url} title={news.source_title}/>
                            </div>
                            <NewsText
                                news={news}
                                isFull={isFull}
                                isDesktop={isDesktop}
                                options={adBlocks}
                            />
                            <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.aa1}/>
                            <SmiWidget blockIds={widgetBlocks.aa2} isFull={isFull} isDesktop={isDesktop}/>
                            <div className="container-post look-also" id="look-also">
                                <h3>Смотрите также</h3>
                                <div className="box">
                                    <SmiWidget blockIds={widgetBlocks.lookAlso} isFull={isFull} isDesktop={isDesktop}/>
                                </div>
                            </div>
                            {!fprVersion &&
                                <SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop}/>}
                            <AdfoxInvisible isTop={true}/>
                            <AdfoxInvisible isTop={false}/>
                        </section>
                        <Sidebar isSticky={widgetBlocks.sideBar.isSticky}>
                            <SmiWidget blockIds={widgetBlocks.sideBar} isFull={isFull} isDesktop={isDesktop}/>
                        </Sidebar>
                    </div>
                    {fprVersion &&
                        <SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop}/>}
                    <footer className="down"/>
                </main>
            </div>
            {widgetBlocks.moeVideo ? <MoeVideo placements={widgetBlocks.moeVideo} isFull={isFull} isDesktop={isDesktop}/> : <BottomAd isFull={isFull} isDesktop={isDesktop} options={adBlocks.floorad}/>}
            <SmiWidget blockIds={widgetBlocks.empty} isFull={isFull} isDesktop={isDesktop}/>
        </div>
    );
}
